"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styles = require("@material-ui/core/styles");

var _core = require("@material-ui/core");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    root: {// maxWidth: 345,
    },
    dialog: {
      maxWidth: 600
    },
    content: {
      padding: theme.spacing(3)
    }
  };
});

var ConfirmDialog = function ConfirmDialog(_ref) {
  var title = _ref.title,
      body = _ref.body,
      message = _ref.message,
      _ref$confirmLabel = _ref.confirmLabel,
      confirmLabel = _ref$confirmLabel === void 0 ? 'Ok' : _ref$confirmLabel,
      _ref$cancelLabel = _ref.cancelLabel,
      cancelLabel = _ref$cancelLabel === void 0 ? 'annuleren' : _ref$cancelLabel,
      resolve = _ref.resolve,
      reject = _ref.reject,
      open = _ref.open,
      handle = _ref.handle;
  var classes = useStyles();

  var _useState = (0, _react.useState)(''),
      _useState2 = _slicedToArray(_useState, 2),
      _message = _useState2[0],
      setMessage = _useState2[1]; // clear message when dialog closes


  (0, _react.useEffect)(function () {
    if (!open) setMessage('');
  }, [open]);

  var cancel = function cancel() {
    reject();
    handle({
      open: false
    });
  };

  var confirm = function confirm(m) {
    resolve(m);
    handle({
      open: false
    });
  };

  return /*#__PURE__*/_react["default"].createElement(_core.Dialog, {
    "aria-labelledby": "simple-dialog-title",
    classes: {
      paper: classes.dialog
    },
    open: open
  }, /*#__PURE__*/_react["default"].createElement(_core.DialogTitle, null, title), /*#__PURE__*/_react["default"].createElement(_core.DialogContent, {
    classes: {
      root: classes.content
    }
  }, /*#__PURE__*/_react["default"].createElement(_core.Typography, {
    variant: "body1"
  }, body), message && /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, /*#__PURE__*/_react["default"].createElement("br", null), " ", /*#__PURE__*/_react["default"].createElement("br", null), /*#__PURE__*/_react["default"].createElement(_core.Typography, {
    variant: "body2"
  }, message), /*#__PURE__*/_react["default"].createElement(_core.TextField, {
    id: "outlined-multiline-static",
    label: "Opmerkingen",
    multiline: true,
    rows: 4,
    variant: "outlined",
    fullWidth: true,
    margin: "normal",
    InputLabelProps: {
      shrink: true
    },
    value: _message,
    onChange: function onChange(event) {
      return setMessage(event.target.value);
    }
  }))), /*#__PURE__*/_react["default"].createElement(_core.DialogActions, null, /*#__PURE__*/_react["default"].createElement(_core.Button, {
    onClick: function onClick() {
      cancel();
    }
  }, cancelLabel), /*#__PURE__*/_react["default"].createElement(_core.Button, {
    variant: "outlined",
    onClick: function onClick() {
      confirm(!!message && _message);
    },
    color: "primary"
  }, confirmLabel)));
};

ConfirmDialog.propTypes = {};
var _default = ConfirmDialog;
exports["default"] = _default;